/* eslint-disable */
<template>
  <div>
     <vs-row class="mb-3" >
      <vs-button color="dark" disabled type="flat"><h5>Device Management  /  Sensor</h5></vs-button>
    </vs-row>
    <!-- <b-breadcrumb style="background-color: #ffffff; padding-left: 0px;">
    <b-breadcrumb-item active><h5>Device Management</h5></b-breadcrumb-item>
    <b-breadcrumb-item active><h5>Sensor</h5></b-breadcrumb-item>
  </b-breadcrumb> -->
    <vs-card style="border-radius: 20px;">
      <div class="mt-2" slot="header" >
        <vs-row id="center">
          <h3  id="p" style="color: #111111">
            Sensor
          </h3>
        <h3 id="v" style="color: #111111">
            Sensor
          </h3>
        <vs-spacer />
           <btnPrint :dataList="sensorlist" :headerName="'Sensor'" :header="header" />
        <vs-tooltip  text="Download a PDF" position="top" >
          <vs-button  radius class="mr-2"  color="#333f50" @click="exportPDF" type="line"   icon="picture_as_pdf"></vs-button></vs-tooltip>
          <vs-tooltip  text="Export" position="top" >
          <vs-button   radius  color="#333f50" type="line" @click="onExport" icon="cloud_download"></vs-button></vs-tooltip>
          <vs-tooltip  text="Add New Sensor" position="top" >
            <h6> <vs-button color="success"  style="border-radius: 20px;" size="sm" icon="add" v-b-modal.addsensor type="filled">Add Sensor</vs-button></h6>
        </vs-tooltip>
        </vs-row> 
       
      <!-- <v-select multiple v-model="selectFilter" :options="header" /> -->
        <vs-row class=" mt-4 mb-1">
           <vs-col style="padding-left: unset;" vs-type="flex"  vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12" >
              <h6>Filters :</h6>
                    <v-select style="min-width: 300px;" class=" ml-3" multiple v-model="selectFilter" :options="header" /><vs-icon class="ml-2" icon="search" id="btns" @click="inputfilter2()" size="20px" color="dark"></vs-icon>
              </vs-col>
        </vs-row>
        <vs-row id="center" class="mb-2" style="display: flex; align-items: center;" :key="index" v-for="(item,index) in selectFilter">
          <vs-icon icon="delete" id="btns"  @click="removeItem(item,index,filtervalue)" size="20px" color="danger"></vs-icon>
             <h6 class="mr-2 ml-1" >{{item}} : </h6>
              <input class="inputx w3-input" style="width: 260px;" @keydown.enter="inputfilter2()"    v-model="filtervalue[index]"/>
              
        </vs-row>
        <b-modal id="addsensor" :no-close-on-backdrop="false" hide-header-close centered hide-footer  size="lg" >
           <template #modal-title>
     <h4 style="color: #5fa74b">Add New Device</h4> 
    </template>
         <div>
           <AddDevice />
        </div>
  </b-modal>
      </div>
  <Table :header="header" :data="sensorlist" :filter="actionchange" :filterlist="nwlist" :viewfunc="link2" :filtername="network" 
         :deleteurl="'sensordel'"/>
    </vs-card>
  </div>
</template>

<script>
import btnPrint from '../Page/Button/btnPrint.vue'
import Table from '../material/Table.vue'
import moment from 'moment'
import AddDevice from '../Page/Subpage/AddDevice.vue'
import XLSX from 'xlsx' // import xlsx
import html2pdf from 'html2pdf.js'
import jsPDF  from 'jspdf'
import 'jspdf-autotable'
export default {
  name: "Sensor",
  
  data: () => ({
    nwlist: [],
    filtervalue: [],
     items: [
      { name: 'Peter', value: '' },
      { name: 'Kitty', value: '' }
    ],
    i: '',
    sensorlist: [],
    selectFilter:[],
     options1:[
        {text: 'Name', value: 'Name'},
        {text: 'Serial Number', value: 'Serial Number'},
        {text: 'Type', value: 'Type'},
        {text: 'Network', value: 'Network'},
        {text: 'Location', value: 'Location'},
        {text: 'Active Status', value: 'Active Status'},
      ],
    d:'',
    network: '',
    role: '',
    a: [],
    filter_input: [ {
      name : '' ,
      serial_id : '',
      type: '',
      network : '',
      location: '',
      active_status: '',
      signal: '',
      battery: '',
      }
    ],
    filter_list: [],
    primeTable: '',
    finds: [],
    counter: 0,
    dataBody: [],
    dataExport: [],
    header: ['Name','Serial Number','Type','Network','Location','Active Status','Signal','Battery']
  }),
  components: {
    Table,
    AddDevice,
    btnPrint
  },
  methods: {
     // print
    //  print() {
    //   console.log(this.sensorlist) 
    //   this.sensorlist.forEach(element => {
    //      this.dataBody.push({name: element.name,serial_id: element.serial_id,type: element.type,network: element.network,location: element.location,active: element.active, signal:'100',bat:'100'});
    //   });
    //   console.log(this.dataBody)
    //   var doc = new jsPDF('p', 'pt');
    //   doc.setFontSize(11).text('Sensor List', 40, 40); //header
    //   var newDat = moment().format('MM/DD/YYYY hh:mm:ss'); 
    //   doc.setFontSize(7).text(505,25,newDat); //timestamp
    //   var values = this.dataBody.map( (elemento) => Object.values(elemento));
    //   console.log(values)
    //   doc.autoTable({theme: 'striped',headStyles: {fillColor: [105, 181, 83] ,textColor: [255, 255, 255]} , styles: { fontSize: 8 ,theme: 'plain'},
    //       head: [['Name','Serial Number','Type','Network','Location','Active Status','Signal','Battery']],
    //       body: values,margin: {top: 50}
    //   })
    //   doc.autoPrint();
    //   doc.output("dataurlnewwindow");
    //   this.dataBody = []; //Clear dataBody
    // },
    // export PDF
     exportPDF() {
      console.log(this.sensorlist) 
      this.sensorlist.forEach(element => {
         this.dataBody.push({name: element.name,serial_id: element.serial_id,type: element.type,network: element.network,location: element.location,active: element.active, signal:'100',bat:'100'});
      });
      console.log(this.dataBody)
      var doc = new jsPDF('p', 'pt');
      doc.setFontSize(11).text('Sensor List', 40, 40); //header
      var newDat = moment().format('MM/DD/YYYY hh:mm:ss'); 
      doc.setFontSize(7).text(505,25,newDat); //timestamp
      var values = this.dataBody.map( (elemento) => Object.values(elemento));
      console.log(values)
      doc.autoTable({theme: 'striped',headStyles: {fillColor: [105, 181, 83] ,textColor: [255, 255, 255]} , styles: { fontSize: 8 ,theme: 'plain'},
          head: [['Name','Serial Number','Type','Network','Location','Active Status','Signal','Battery']],
          body: values,margin: {top: 50}
      })
      doc.save('exportSensorList.pdf'); 
      this.dataBody = []; //Clear dataBody
    },
    // export xlsx
    onExport() {
      this.sensorlist.forEach(element => {
         this.dataExport.push({name: element.name,serial_id: element.serial_id,type: element.type,network: element.network,location: element.location,active: element.active, signal:'100',bat:'100'});
      });
      const dataWS = XLSX.utils.json_to_sheet(this.dataExport)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb,'exportSensor.xlsx')
      this.dataExport = [];
    },
    inputfilter2(){
      function addfilter(item,filtervalue,filter_input){
        if(item == 'Name'){
          filter_input[0].name = filtervalue
        }
        else if(item == 'Serial Number'){
          // this.filter_input[0]['serial_id'] = filtervalue
          filter_input[0].serial_id = filtervalue
        }
        else if(item == 'Type'){
          filter_input[0].type = filtervalue
        }
        else if(item == 'Network'){
          filter_input[0].network = filtervalue
        }
        else if(item == 'Location'){
          filter_input[0].location = filtervalue
        }
        else if(item == 'Active Status'){
          filter_input[0].active_status = filtervalue
        }
        else if(item == 'Signal'){
          filter_input[0].signal = filtervalue
        }
        else if(item == 'Battery'){
          filter_input[0].battery = filtervalue
        }
      }
      // console.log(this.filtervalue)
      for(let index in this.selectFilter){
        var item = this.selectFilter[index]
        var filtervalue = this.filtervalue[index]
        addfilter(item,filtervalue,this.filter_input)
      }
      var body = this.filter_input[0]
      this.filter_list = []
      this.$http.post(this.$url2+'sensorfilter/'+this.$session.get('username'),body).then((result)=>{
        if(result){
          // console.log(result.status)
          result.data.forEach(element=>{
            this.filter_list.push({name: element.name,serial_id: element.serial_id,type: element.type, network: element.network, location:'Unavailable', active:element.active, signal:'100',bat:'100'})
          })
          if(this.counter == 0){
            this.counter += 1
            this.sensorlist= this.filter_list
          }
          else{
            this.sensorlist = this.filter_list
            this.counter += 1
          }
          // console.log(result.data)
        }
      }).catch((err)=>{
        if(err.response.status==500){
          this.sensorlist = []
        }
      })
    },
    removeItem(item,index,filtervalue) {
      var count = 0
      //Delete Filter
      // console.log(this.selectFilter)
      // console.log(item)
      // console.log(index)
      this.$delete(this.selectFilter,index)
      // Delete value of index from filter
      if (index > -1) {
        filtervalue.splice(index, 1);
      }
      // console.log(this.filtervalue)
      function deletefilter(item,filter_input){
        if(item == 'Name'){
          filter_input[0].name = ''
        }
        else if(item == 'Type'){
          filter_input[0].type = ''
        }
        else if(item == 'Serial Number'){
          filter_input[0].serial_id = ''
        }
        else if(item == 'Network'){
          filter_input[0].network = ''
        }
        else if(item == 'Location'){
          filter_input[0].location = ''
        }
        else if(item == 'Active Status'){
          filter_input[0].active_status = ''
        }
        else if(item == 'Signal'){
          filter_input[0].signal = ''
        }
        else if(item == 'Battery'){
          filter_input[0].battery = ''
        }
      }
      deletefilter(item,this.filter_input)
      var filter_data = this.filter_input[0]

      //Check filterinput data
      for(let i in filter_data){
        if(filter_data[i].length != 0){
          count+= 1
        }
      }
      //When delete filter
      if(count == 0 && filtervalue.length==0){
        this.sensorlist = this.primeTable
        this.counter = 0
        // console.log("case1")
      }
      else{
        // console.log("case2")
        var body = this.filter_input[0]
        this.filter_list = []
        this.$http.post(this.$url2+'sensorfilter/'+this.$session.get('username'),body).then((result)=>{
          if(result){
            result.data.forEach(element=>{
            this.filter_list.push({name: element.name,serial_id: element.serial_id,type: element.type, network: element.network, location:'Unavailable', active:element.active, signal:'100',bat:'100'})
            })
            this.sensorlist = this.filter_list
          }
        }).catch((err)=>{
          // console.log(err)
        })
      }
    },
    inputfilter(item,filtervalue,filterarray){
      this.filtervalue
      function addfilter(filtervalue,filter_input){
        if(item == 'Name'){
          filter_input[0].name = filtervalue
        }
        else if(item == 'Serial Number'){
          // this.filter_input[0]['serial_id'] = filtervalue
          filter_input[0].serial_id = filtervalue
        }
        else if(item == 'Type'){
          filter_input[0].type = filtervalue
        }
        else if(item == 'Network'){
          filter_input[0].network = filtervalue
        }
        else if(item == 'Location'){
          filter_input[0].location = filtervalue
        }
        else if(item == 'Active Status'){
          filter_input[0].active_status = filtervalue
        }
        else if(item == 'Signal'){
          filter_input[0].signal = filtervalue
        }
        else if(item == 'Battery'){
          filter_input[0].battery = filtervalue
        }
      }
      addfilter(filtervalue,this.filter_input)
      var body = this.filter_input[0]
      this.filter_list = []
      this.$http.post(this.$url2+'sensorfilter/'+this.$session.get('username'),body,{
      headers: {
      'Access-Control-Request-Method': '*',
      'Access-Control-Request-Headers': '*',
      'Access-Control-Allow-Origin': '*'
      },
      username: "admin",
      password: "admin",
      role: this.checkbox
      }).then((result)=>{
        // console.log(result)
        if(result){
          result.data.forEach(element=>{
            this.filter_list.push({name: element.name,serial_id: element.serial_id,type: element.type, network: element.network, location:'Unavailable', active:element.active, signal:'100',bat:'100'})
          })
          if(this.counter == 0){
            this.primeTable = this.sensorlist
            this.counter += 1
            this.sensorlist= this.filter_list
          }
          else{
            this.sensorlist = this.filter_list
            this.counter += 1
          }
          // console.log(result.data)
        }
      }).catch((err)=>{
        // console.log(err)
      })
    },
    async actionchange(item) {
      
      var id = item.id
      var name = item.name
      this.ismounted = false
      // console.log(name)
      this.network = name
      this.selectedFilter = name
      this.sensorlist = []
      if(name == 'All Network') {
        await this.$http.get(this.$url+'sensorid/'+this.$session.get('token')).then((result) => {
          result.data.forEach(element => {
            this.sensorlist.push({name: element.name,serial_id: element.serial_id,type: element.type, network: element.network, location:'Unavailable', active:element.active, signal:'100',bat:'100'})
          });
        })
      }else {
        await this.$http.get(this.$url+'sensors/'+id+'/'+this.$session.get('token')).then((result) => {
          result.data.forEach(element => {
            this.sensorlist.push({name: element.name,serial_id: element.serial_id,type: element.type, network: element.network, location:'Unavailable', active:element.active, signal:'100',bat:'100'})
          });
        })
      }
      // eslint-disable-next-line no-console
      // console.log(this.sensorlist)
    },
    link(){
      this.$router.push({
        name: 'AddDevice',
        params: {
          nwname: this.name,
          nwid: this.id
        }
      })
    },
    link2(item){
      // this.$session.set('nwname',this.network)
      this.$session.set('nwname',item.network)
      this.$session.set('statussensor',item.active)
      this.$session.set('nwid', item.nwid)
      this.$session.set('sensorname', item.name)
      this.$session.set('sensorid', item.serial_id)
      this.$session.set('gatewayid', item.gatewayid)
      this.$session.set('type', item.type)
      this.$session.set('lora', item.lora)
      // console.log(this.network,item)
      this.$router.push({
        name: 'SensorDashboard',
        params: {
          nwname: this.network,
          nwid: item.nwid,
          sensorid: item.serial_id,
          gatewayid: item.gatewayid,
          type: item.type
        }
      })
    },
  },
  created() {
    this.role = this.$session.get('role')
    this.$http.get(this.$url+'network/'+this.$session.get('token')).then((result)=>{
      this.nwlist = result.data
      // console.log(this.nwlist)
      this.nwlist.unshift({"id":0,"name":"All Network"})
      this.network = result.data[0].name
    })
    this.$http.get(this.$url+'sensorid/'+this.$session.get('token')).then((result) => {
      // this.sensorlist = result.data
      // console.log(result.data)
      result.data.forEach(element => {
        // // console.log(element)
        if(element.lora) this.sensorlist.push({name: element.name,serial_id: element.serial_id,type: element.type, network: element.network, location:'Unavailable', active:element.active, signal:'100',bat:'100',lora:element.lora})
        else this.sensorlist.push({name: element.name,serial_id: element.serial_id,gatewayid: element.gatewayid, type: element.type, network: element.network, location:'Unavailable', active:element.active, signal:'100',bat:'100'})
      });
      // console.log(this.sensorlist)
      this.primeTable = this.sensorlist
    })
  }
}
</script>
<style scoped>
#btns{
   cursor: pointer;
}
#center{
  display: flex;
  align-items: center;
}
.w3-disabled *, :disabled * {
    color: black
}
  button#dropdown-1_BV_toggle_.btn.dropdown-toggle.btn-secondary {
    border-radius: 5px;
  }
  th .sort-th .th-sort-icon {
    color: white;
    padding: 0px;
}
#v {
  display: none;
}
 
#btncancel{
  background-color: #ffffff;
  border-radius: 0;
  border-color: #ffffff;
}
 
@media screen and (max-width: 600px) {
  #v{
    display: inline;
    padding: 0px;
    right: -20px;
  }
  #p{
    display: none;
  }
  .a{
     /* background: pink; */
     width: 200px;
   }
   .vuesax-app-is-ltr .vs-table--search-input{
     width: 100px;
     padding: o;
   }
   .vuesax-app-is-ltr .vs-table--search i {
    left: 15px;
} 
 
        }
</style>